function dynamicMedia() {
  const pdpNotes = document.querySelector('.pdp__notes');

  if (!pdpNotes) {
    return;
  }

  const dynamicItems = pdpNotes.querySelectorAll('.pdp__notes-list-wrap');
  const mediaImage = document.querySelector('.pdp__notes-main-media img');
  const mediaVideo = document.querySelector('.pdp__notes-main-media video');

  dynamicItems.forEach((item) => {
    item.addEventListener('mouseover', (e) => {
      e.preventDefault();

      const mediaSrc = item.getAttribute('data-media');
      const mediaType = item.getAttribute('data-type');
      dynamicItems.forEach((el) => {
        el.classList.remove('active');
      });
      item.classList.add('active');
      if (mediaType === "image") {
        mediaImage.src = mediaSrc;
        mediaVideo.classList.add('hidden');
        mediaImage.classList.remove('hidden');
      } else if (mediaType === "video") {
        mediaVideo.src = mediaSrc;
        mediaImage.classList.add('hidden');
        mediaVideo.classList.remove('hidden');
        mediaVideo.play();
      }
    });
  });

}

export default dynamicMedia;
